import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-report-type-select-modal',
  templateUrl: './report-type-select-modal.component.html',
  styleUrls: ['./report-type-select-modal.component.css']
})
export class ReportTypeSelectModalComponent implements OnInit {

  @Input() translatekey: string;
  @Input() values: String[];
  @Input() selected: string;

  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  setSelected(value) {
    this.passEntry.emit(value);

  }

  close() {
    this.passEntry.emit();
  }
}
